import { useState } from 'react';
import { Settings2, X } from 'lucide-react';
import { FilterSet } from '#server/models';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerTrigger,
  DrawerFilter,
  Filter,
  FilterHeader,
  ShadCNButton,
  Divider,
  SortBy,
} from '@/components';
import { useFilterStore, useFilterActions } from '@/store';
import { countFilters } from '@/utils';

interface FilterProps {
  filterData?: FilterSet | null;
  facet?: string;
}

export const FilterDrawer = ({ filterData }: FilterProps) => {
  const { activeFilters } = useFilterStore();
  const { clearFilters } = useFilterActions();
  const [isOpen, setIsOpen] = useState(false);

  const totalFilters = countFilters(filterData, activeFilters);

  return (
    <Drawer onOpenChange={setIsOpen}>
      <DrawerTrigger asChild className="fixed bottom-5 right-5">
        <ShadCNButton tabIndex={isOpen ? -1 : 0} size="icon" className="size-[60px] rounded-full bg-black hover:bg-primary z-50">
          {totalFilters > 0 && (
            <div className="absolute -top-1 right-0 flex size-6 items-center justify-center rounded-full bg-primary text-white">
              {totalFilters}
            </div>
          )}
          <Settings2 className="size-7 text-white" />
        </ShadCNButton>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader className="relative flex-row items-center justify-center">
          <DrawerTitle tabIndex={-1} className="sr-only">
            Result Filters
          </DrawerTitle>
          <DrawerDescription className="sr-only">A list of filters for the results</DrawerDescription>
          <FilterHeader totalFilters={totalFilters} clearFilters={clearFilters} mobile />
          <DrawerClose asChild className="absolute right-4">
            <ShadCNButton size="icon" className="group rounded-full bg-secondary-grey-05">
              <X className="text-black group-hover:text-white group-focus:text-white" />
            </ShadCNButton>
          </DrawerClose>
        </DrawerHeader>
        <Divider className="mx-4 w-[calc(100%-2rem)]" />
        <div className="mx-4 flex py-4">
          <SortBy />
        </div>
        <Divider className="mx-4 w-[calc(100%-2rem)]" />
        <DrawerFilter className="overflow-auto">
          <Filter filterData={filterData} mobile />
        </DrawerFilter>
        <DrawerFooter>
          <ShadCNButton variant="white" onClick={clearFilters}>
            Clear all
          </ShadCNButton>
          <DrawerClose asChild>
            <ShadCNButton>Search</ShadCNButton>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
